var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { GraphQLNonEmptyString } from "graphql-scalars";
import { ArgsType, Field, InputType, Int, ObjectType } from "type-graphql";
import { FilteredListQueryArgs } from "../filtering/FilteredListQueryArgs.js";
import { TeamLegacyStatus, TeamNode, TeamType } from "../resources/Team.js";
import { AbstractGraphQLPaginatedResponse } from "./PaginatedResponse.js";
let ListTeamsResponse = class ListTeamsResponse extends AbstractGraphQLPaginatedResponse {
    data;
};
__decorate([
    Field(() => [TeamNode]),
    __metadata("design:type", Array)
], ListTeamsResponse.prototype, "data", void 0);
ListTeamsResponse = __decorate([
    ObjectType("ListTeamsResponse", {
        implements: (AbstractGraphQLPaginatedResponse),
    })
], ListTeamsResponse);
export { ListTeamsResponse };
let CreateTeamInput = class CreateTeamInput {
    name;
    type;
    legacyStatus;
};
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: false }),
    __metadata("design:type", String)
], CreateTeamInput.prototype, "name", void 0);
__decorate([
    Field(() => TeamType, { nullable: false }),
    __metadata("design:type", String)
], CreateTeamInput.prototype, "type", void 0);
__decorate([
    Field(() => TeamLegacyStatus, { nullable: false }),
    __metadata("design:type", String)
], CreateTeamInput.prototype, "legacyStatus", void 0);
CreateTeamInput = __decorate([
    InputType()
], CreateTeamInput);
export { CreateTeamInput };
let SetTeamInput = class SetTeamInput {
    name;
    type;
    legacyStatus;
    persistentIdentifier;
};
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], SetTeamInput.prototype, "name", void 0);
__decorate([
    Field(() => TeamType, { nullable: true }),
    __metadata("design:type", Object)
], SetTeamInput.prototype, "type", void 0);
__decorate([
    Field(() => TeamLegacyStatus, { nullable: true }),
    __metadata("design:type", Object)
], SetTeamInput.prototype, "legacyStatus", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], SetTeamInput.prototype, "persistentIdentifier", void 0);
SetTeamInput = __decorate([
    InputType()
], SetTeamInput);
export { SetTeamInput };
let BulkTeamInput = class BulkTeamInput {
    name;
    type;
    legacyStatus;
    captainLinkblues;
    memberLinkblues;
};
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: false }),
    __metadata("design:type", String)
], BulkTeamInput.prototype, "name", void 0);
__decorate([
    Field(() => TeamType, { nullable: false }),
    __metadata("design:type", String)
], BulkTeamInput.prototype, "type", void 0);
__decorate([
    Field(() => TeamLegacyStatus, { nullable: false }),
    __metadata("design:type", String)
], BulkTeamInput.prototype, "legacyStatus", void 0);
__decorate([
    Field(() => [GraphQLNonEmptyString], { nullable: true }),
    __metadata("design:type", Object)
], BulkTeamInput.prototype, "captainLinkblues", void 0);
__decorate([
    Field(() => [GraphQLNonEmptyString], { nullable: true }),
    __metadata("design:type", Object)
], BulkTeamInput.prototype, "memberLinkblues", void 0);
BulkTeamInput = __decorate([
    InputType()
], BulkTeamInput);
export { BulkTeamInput };
let ListTeamsArgs = class ListTeamsArgs extends FilteredListQueryArgs("TeamResolver", [
    "name",
    "type",
    "legacyStatus",
    "marathonYear",
    "totalPoints",
]) {
};
ListTeamsArgs = __decorate([
    ArgsType()
], ListTeamsArgs);
export { ListTeamsArgs };
let DbFundsTeamInfo = class DbFundsTeamInfo {
    dbNum;
    name;
};
__decorate([
    Field(() => Int, { nullable: false }),
    __metadata("design:type", Number)
], DbFundsTeamInfo.prototype, "dbNum", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", String)
], DbFundsTeamInfo.prototype, "name", void 0);
DbFundsTeamInfo = __decorate([
    ObjectType("DbFundsTeamInfo")
], DbFundsTeamInfo);
export { DbFundsTeamInfo };
//# sourceMappingURL=SingleTeamResponse.js.map